import { configureStore } from '@reduxjs/toolkit'

import userdataSlice from './store/userdata';

export default configureStore({
  reducer: {
    userdata: userdataSlice
  },
})